/**
 * Este es el entorno de pruebas.
 */
export const environment = {
  /**
   * Indica si la aplicación se está ejecutando en modo de producción.
   * 
   * @type {boolean}
   */
  production: false,

  /**
   * URL de la API a la que se conectará la aplicación.
   * 
   * @type {string}
   */
  apiUrl: 'https://licenseswebstaging.danzaiapps.com',

  /**
   * URL de la API a la que se conectará a Dansap.
   * 
   * @type {string}
   */
  dansapApiUrl: 'https://licencesstaging.danzaiapps.com/web',

  /**
   * API Key de Dansap.
   * 
   * @type {string}
   */
  dansapApiKey: 'tw2000',
};
